import { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Col, Input, Label } from 'reactstrap';
import { Collapse } from 'reactstrap';
import { Search } from 'react-feather';
import { Filter } from 'Constant';
import { H5, Btn } from 'AbstractElements';
import { useSelector, useDispatch } from 'react-redux';
import { setFilters } from 'Features/Learning/Users/userSlice';
import AsyncSelectCommon from 'Component/Learning/Common/SelectOption/AsyncSelect';
import { fetchUser } from '../UsersUtils';
import { fetchMemberships } from 'Features/Learning/Memberships/Utils/MembershipUtils';
import RadioFilter from 'Component/Learning/Common/Filter/RadioFilter';
import { getSource } from 'Features/Learning/Tryout/Utils/TryoutUtils';

const FindUser = () => {
  const [isFilter, setIsFilter] = useState(true);
  const dispatch = useDispatch();
  const filters = useSelector(state => state.User.filters);
  const filterMemberships = useSelector(state => state.Membership.filters);
  const [selectedValue, setSelectedValue] = useState(null);
  const [sourceOptions, setSourceOptions] = useState([]);
  // Simpan semua perubahan filter di lokal dulu, baru apply saat tombol Filter diklik.
  const [draftFilters, setDraftFilters] = useState(filters);

  // State untuk date filter
  const [createdDateFrom, setCreatedDateFrom] = useState(draftFilters['filter[created_date_from]'] || '');
  const [createdDateTo, setCreatedDateTo] = useState(draftFilters['filter[created_date_to]'] || '');

  useEffect(() => {
    setDraftFilters(filters);
    setCreatedDateFrom(filters['filter[created_date_from]'] || '');
    setCreatedDateTo(filters['filter[created_date_to]'] || '');
  }, [filters]);

  useEffect(() => {
    const selectedMembership = draftFilters['filter[membership.title]']
      ? {
        value: draftFilters['filter[membership.id]'],
        label: draftFilters['filter[membership.title]']
      }
      : null;
    setSelectedValue(selectedMembership);
  }, [draftFilters]);

  const promiseOptions = (inputValue, callback) => {
    // console.log('Input Value = ', inputValue)
    if (inputValue !== '') {
      dispatch(fetchMemberships({
        ...filterMemberships,
        'filter[title]': inputValue,
        'sort': 'title',
        'page': 1,
      }))
        .then((response) => {
          const options = response.payload.data.map(item => ({
            value: item.id,
            label: item.title,
          }));
          callback(options);
        })
        .catch((error) => {
          console.error('Error fetching options:', error);
          callback([]);
        });
    }
  };

  const handleSelectChange = (selectedOption) => {
    setSelectedValue(selectedOption);

    setDraftFilters((prevFilters) => ({
      ...prevFilters,
      'filter[membership.title]': selectedOption ? selectedOption.label : '',
      'filter[membership.id]': selectedOption ? selectedOption.value : '',
    }));
  };

  const handleClickSearch = (e) => {
    e.preventDefault();

    // Pastikan filter[name_start] tetap string saat request
    const safeNameStart = Array.isArray(draftFilters['filter[name_start]'])
      ? draftFilters['filter[name_start]'][0] || ''
      : draftFilters['filter[name_start]'] || '';

    const newFilters = {
      ...draftFilters,
      'filter[name_start]': safeNameStart,
      'page': 1,
    };

    dispatch(setFilters(newFilters));
    fetchUser(dispatch, newFilters);
  }

  const handleResetFilter = () => {
    const newFilters = {
      ...draftFilters,
      'filter[id]': '',
      'filter[name]': '',
      'filter[name_start]': '',
      'filter[username]': '',
      'filter[email]': '',
      'filter[gender]': '',
      'filter[phone]': '',
      'filter[address]': '',
      'filter[order.status]': '',
      'filter[order.payment_method]': '',
      'filter[membership.title]': '',
      'filter[membership.id]': '',
      'filter[referral_code]': '',
      'filter[source]': '',
      'filter[created_date_from]': '',
      'filter[created_date_to]': '',
      'filter[verified]': '',
      'sort': '',
      'page': 1,
    };
    setSelectedValue(null)
    setCreatedDateFrom('');
    setCreatedDateTo('');
    setDraftFilters(newFilters);
    dispatch(setFilters(newFilters));
    fetchUser(dispatch, newFilters);
  }

  const updateDraftFilters = (field, value) => {
    setDraftFilters((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  const handleSortBy = () => (e) => {
    const filterValue = e.target.value;
    updateDraftFilters('sort', filterValue);
  };

  const promiseSourceOptions = (inputValue, callback) => {
    const keyword = (inputValue || '').toLowerCase();

    // Saat select dibuka (input kosong), hit API untuk ambil semua source terbaru.
    if (!keyword) {
      dispatch(getSource())
        .then((response) => {
          const options = (response?.payload?.data || []).map(item => ({ value: item, label: item }));
          setSourceOptions(options);
          callback(options);
        })
        .catch(() => {
          setSourceOptions([]);
          callback([]);
        });
      return;
    }

    // Kalau user search, filter manual dari data source yang sudah ada.
    const options = sourceOptions.filter(item => item.label.toLowerCase().includes(keyword));
    callback(options);
  };

  return (
    <Col xl="12">
      <Card>
        <CardHeader>
          <H5 attrH5={{ className: 'mb-0' }} >
            <Btn attrBtn={{ className: 'btn btn-link ps-0', onClick: () => setIsFilter(!isFilter), color: 'transperant', datastoggle: 'collapse', databstarget: '#collapseicon', ariaexpanded: 'true', ariacontrols: 'collapseicon' }} >{'Temukan User'}</Btn>
          </H5>
        </CardHeader>
        <Collapse isOpen={isFilter}>
          <div className="collapse show" id="collapseicon" aria-labelledby="collapseicon" data-parent="#accordion">
            <CardBody className="filter-cards-view animate-chk">
              <div className="job-filter mb-4">
                <div className="faq-form">
                  <Input className="form-control" type="text" placeholder="Cari nama.."
                    value={draftFilters['filter[name]']}
                    onKeyUp={(e) => e.key === 'Enter' ? handleClickSearch(e) : null}
                    onChange={(e) => {
                      updateDraftFilters('filter[name]', e.target.value);
                    }}
                  />
                  <Search className="search-icon" />
                </div>
              </div>
              <div className="job-filter mb-4">
                <div className="faq-form">
                  <Input className="form-control" type="text" placeholder="Cari nama berawalan.."
                    value={draftFilters['filter[name_start]']}
                    onKeyUp={(e) => e.key === 'Enter' ? handleClickSearch(e) : null}
                    onChange={(e) => {
                      updateDraftFilters('filter[name_start]', e.target.value);
                    }}
                  />
                  <Search className="search-icon" />
                </div>
              </div>
              <div className="job-filter mb-4">
                <div className="faq-form">
                  <Input className="form-control" type="text" placeholder="Cari email.."
                    value={draftFilters['filter[email]']}
                    onKeyUp={(e) => e.key === 'Enter' ? handleClickSearch(e) : null}
                    onChange={(e) => {
                      updateDraftFilters('filter[email]', e.target.value);
                    }}
                  />
                  <Search className="search-icon" />
                </div>
              </div>
              <div className="job-filter mb-4">
                <div className="faq-form">
                  <Input className="form-control" type="text" placeholder="Cari nomer telp.."
                    value={draftFilters['filter[phone]']}
                    onKeyUp={(e) => e.key === 'Enter' ? handleClickSearch(e) : null}
                    onChange={(e) => {
                      updateDraftFilters('filter[phone]', e.target.value);
                    }}
                  />
                  <Search className="search-icon" />
                </div>
              </div>
              <div className="job-filter mb-4">
                <div className="faq-form">
                  <Input className="form-control" type="text" placeholder="Cari kode referral"
                    value={draftFilters['filter[referral_code]']}
                    onKeyUp={(e) => e.key === 'Enter' ? handleClickSearch(e) : null}
                    onChange={(e) => {
                      updateDraftFilters('filter[referral_code]', e.target.value);
                    }}
                  />
                  <Search className="search-icon" />
                </div>
              </div>
              <div className="job-filter mb-4">
                <div className="faq-form">
                  <AsyncSelectCommon
                    placeholder={"Cari source.."}
                    isMulti={false}
                    promiseOptions={promiseSourceOptions}
                    handleSelectChange={(selectedOption) => {
                      updateDraftFilters('filter[source]', selectedOption ? selectedOption.value : '');
                    }}
                    selectedValue={draftFilters['filter[source]'] ? { value: draftFilters['filter[source]'], label: draftFilters['filter[source]'] } : null}
                    value={draftFilters['filter[source]'] || ''}
                  />
                </div>
              </div>

              <div className="job-filter mb-4">
                <Label for='created_date_from'>Mulai dari:</Label>
                <Input
                  type="date"
                  id="created_date_from"
                  className="form-control"
                  value={createdDateFrom}
                  onChange={e => {
                    setCreatedDateFrom(e.target.value);
                    updateDraftFilters('filter[created_date_from]', e.target.value);
                  }}
                  placeholder="Mulai dari:"
                />
              </div>
              <div className="job-filter mb-4">
                <Label for='created_date_to'>Sampai dengan:</Label>
                <Input
                  type="date"
                  id="created_date_to"
                  className="form-control"
                  value={createdDateTo}
                  onChange={e => {
                    setCreatedDateTo(e.target.value);
                    updateDraftFilters('filter[created_date_to]', e.target.value);
                  }}
                  placeholder="Sampai dengan:"
                />
              </div>
              <RadioFilter sort={'Status :'}>
                <Label className="d-block" htmlFor="verified_null">
                  <Input className="radio_animated" id="verified_null" type="radio" name="filter[verified]"
                    value="0"
                    checked={draftFilters['filter[verified]'] === '0'}
                    onChange={(e) => {
                      updateDraftFilters('filter[verified]', e.target.value);
                    }}
                  />
                  Belum Verifikasi
                </Label>
                <Label className="d-block" htmlFor="verified_not_null">
                  <Input className="radio_animated" id="verified_not_null" type="radio" name="filter[verified]"
                    value="1"
                    checked={draftFilters['filter[verified]'] === '1'}
                    onChange={(e) => {
                      updateDraftFilters('filter[verified]', e.target.value);
                    }}
                  />
                  Sudah Verifikasi
                </Label>
              </RadioFilter>
              <div className="job-filter mb-4">
                <div className="faq-form">
                  {/* <Input className="form-control" type="text" placeholder="Cari membership.." 
                      value={filters['filter[membership.title]']}
                      onKeyUp={(e) => e.key === 'Enter' ? handleClickSearch(e): null}
                      onChange={(e) => {
                        dispatch(setFilters({
                          ...filters,
                          'filter[membership.title]': e.target.value
                        }));
                      }}
                    /> */}
                  <AsyncSelectCommon label={'Membership'} placeholder={'Cari membership..'}
                    isMulti={false}
                    promiseOptions={promiseOptions}
                    handleSelectChange={(selectedOption) => handleSelectChange(selectedOption)}
                    selectedValue={selectedValue}
                  />
                  <Search className="search-icon" />
                </div>
              </div>
              <div className="checkbox-animated mt-0">
                <div className="learning-header"><span className="f-w-600">Sort by:</span></div>
                <Label className="d-block" htmlFor="sort-new">
                  <Input className="radio_animated" id="sort-new" type="radio" name="sort"
                    checked={draftFilters.sort === '-id'}
                    value="-id"
                    onChange={handleSortBy()}
                  />
                  {'Terbaru'}
                </Label>
                <Label className="d-block" htmlFor="sort-old">
                  <Input className="radio_animated" id="sort-old" type="radio" name="sort"
                    checked={draftFilters.sort === 'id'}
                    value="id"
                    onChange={handleSortBy()}
                  />
                  {'Terlama'}
                </Label>
                <Label className="d-block" htmlFor="sort-az">
                  <Input className="radio_animated" id="sort-az" type="radio" name="sort"
                    checked={draftFilters.sort === 'name'}
                    value="name"
                    onChange={handleSortBy()}
                  />
                  {'A-Z'}
                </Label>
                <Label className="d-block" htmlFor="sort-za">
                  <Input className="radio_animated" id="sort-za" type="radio" name="sort"
                    checked={draftFilters.sort === '-name'}
                    value="-name"
                    onChange={handleSortBy()}
                  />
                  {'Z-A'}
                </Label>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Btn attrBtn={{ color: 'primary text-center p-1', onClick: handleClickSearch }}>{Filter}</Btn>
                </div>
                <div className="col-md-6">
                  <Btn attrBtn={{ color: 'warning text-center p-1', onClick: handleResetFilter }}>{'Reset'}</Btn>
                </div>
              </div>
            </CardBody>
          </div>
        </Collapse>
      </Card>
    </Col>
  );
};

export default FindUser;